<template>
  <div class="cHeader flex justify-content-space-between align-items-center">
    <div class="flex align-items-center">
      <img src="@/assets/header.svg" alt="logo" class="left-logo" v-if="app_type == 'user' || app_type == 'admin'"/>
      <img src="@/assets/header_man.svg" alt="logo" class="left-logo" v-if="app_type == 'man'"/>
      <div class="newColor" @click="jumpMarketing" v-if="app_type=='man'">
          去营销平台
          <i class="el-icon-upload2"></i>
      </div>
    </div>
    <div class="user-info flex align-items-center">
      <div class="updown" @click="showDiag" v-if="app_type=='man'">
        <i class="el-icon-sort"></i>
        上传下载
      </div>
      <div class="free-material">
        <!-- <a href="//sucai.jd.com/?userSource=111"> -->
        <img src="@/assets/编组.png" alt="" />

        <a href="//sucai.jd.com/?userSource=111">版权素材中心(免费)</a>
        <!-- </a> -->
      </div>
      <el-dropdown @command="handleCommand">
        <span
          class="el-dropdown-link flex align-items-center justify-content-center"
        >
          <div
            class="headerPic-wrap flex align-items-center justify-content-center"
          >
            <img :src="userInfo && userInfo.headPic ? imgHost + userInfo.headPic : defaultImage" alt="headPic" />
          </div>
          <div class="userName">
            <span class="hello">Hello,</span>
            <span class="nickName">{{ nickName }}</span>
          </div>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog title="上传下载列表" :visible.sync="upDownListVisible" width="50%" @close='closeDialog'>
      <el-table :data="list" style="width: 100%">
        <el-table-column prop="fileName" label="文件名"></el-table-column>
        <el-table-column label="类型" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.importExportType == 1 ? '导入': '导出' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="250">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.updateTime).toLocaleString() }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span>{{ ['', '待执行', '执行中', '执行成功', '执行失败'][scope.row.importExportStatus] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="查看">
          <template slot-scope="scope">
            <div>
              <el-button class="operateBtn" type="text" size="small" v-if="scope.row.failFileUrl" @click="downLoadFile(scope.row)">查看失败原因</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination @sizePageChange="val => { pagination = val; getPageData(); }" :paginationDatas="pagination" />
    </el-dialog>
  </div>
</template>

<script>
import defaultImage from "@/assets/default-header.png";
import { mapState,mapActions } from "vuex";
import utils from "@/utils";
import { pageImportExportResult } from '@/api/man'
export default {
  name: "cHeader",
  data() {
    return {
      headPic: "",
      defaultImage: defaultImage,
      app_type: process.env.VUE_APP_TYPE,
      upDownListVisible: false,
      list: [],
      // 分页
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
    };
  },
  computed: {
    ...mapState(["imgHost", "userInfo"]),
    nickName(){
      var userInfo = this.userInfo;
      if(!userInfo){
        return '';
      }
      var name;
      if(process.env.VUE_APP_TYPE=='user'){
        if(userInfo.auditStatus == 2){
          name = userInfo.nickName || userInfo.name || userInfo.pin;
        }else{
          name = '未认证游客';
        }
      }else{
        name = userInfo.nickName || userInfo.name || userInfo.pin;
      }
      return name;
    },
  },
  methods: {
    ...mapActions(["logout"]),
    handleCommand(command) {
      // function getCookie($name) {
      //   var data = document.cookie;
      //   var dataArray = data.split("; ");
      //   for (var i = 0; i < dataArray.length; i++) {
      //     var varName = dataArray[i].split("=");
      //     if (varName[0] == $name) {
      //       return decodeURI(varName[1]);
      //     }
      //   }
      // }
      // function delAllCookie() {
      //   var myDate = new Date();
      //   myDate.setTime(0); //设置时间
      //   var data = document.cookie;
      //   var dataArray = data.split("; ");
      //   for (var i = 0; i < dataArray.length; i++) {
      //     var varName = dataArray[i].split("=");
      //     document.cookie = varName[0] + "=''; expires=" + myDate.toGMTString();
      //   }
      // }
      // 调用登录组件退出登录方法
      const options = Object.assign({}, utils.loginOptions);
      if (process.env.VUE_APP_TYPE == 'admin') {
        options.protocol = 'http';
      }
      window.jdLoginTools_create_by_team_aris.logout(options);
      // 删除store 中的登录信息
      this.logout();
      // 退出loading
      $('body').append(`<div id="div_logoutLoading">
        <div class="bg"></div>
        <div class="popwin">
          正在退出，请稍等...！
        </div>
      </div>`);
    },
    jumpMarketing() {
      const tenantId = this.$commonJs.getTenantId()
      if( process.env.VUE_APP_BASEURL == "//beta-api.m.jd.com") {
        window.open(`https://cont-market-beta.jd.com/marketing/activities?tenantId=${tenantId}&source=content&logintype=erp`)
      } else {
        window.open(`https://cont-market.jd.com/marketing/activities?tenantId=${tenantId}&source=content&logintype=erp`)
      }

    },
    showDiag() {
      this.upDownListVisible = true;
      this.getPageData();
    },
    closeOutDialog() {
      this.pagination= {
        total: 0,
        currentPage: 1,
        pageSize: 10
      }
      this.list = [];
    },
    getPageData() {
      pageImportExportResult({
        tenantId: this.$commonJs.getTenantId(),
        // importExportCodes: [1,2,3,4,5,6,8,9,10,11,12,13],
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.currentPage
      }).then(res=> {
        console.log('getPageImportExportResult', res)
        if (res) {
          this.list = res.data;
          this.pagination.total = res.totalCount;
          this.pagination.currentPage = res.pageNo;
          this.pagination.pageSize = res.pageSize;
        }
      })
    },
    // 下载失败原因文件
    downLoadFile(row) {
      console.log('row', row)
      window.open(row.failFileUrl);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/common/mixin.scss';
$color:#266CEE;
.cHeader {
  padding: 0 26px 0 28px;
  height: 70px;
  width: 100%;
  background: white;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(223,223,233,1);
  .left-logo {
    width: 320px;
    height: 32px;
  }
  .user-info {
    .headerBz {
      margin-right: 20px;
      & > img {
        width: 32px;
        height: 30px;
      }
      .headerContent {
        margin-left: 10px;
        font-size: 14px;
        color: #8b8c9a;
      }
    }
    .headerPic-wrap {
      height: 40px;
      width: 40px;
      border: 2px solid $color;
      border-radius: 20px;
      margin-right: 12px;
      img {
        width: 30px;
        height: 30px;
        border-radius: 15px;
      }
    }
    .userName{
      display: inline-block;
      max-width: 340px;
      @include singleline-ellipsis;
      span {
        font-size: 14px;
        color: rgba(139, 140, 154, 1);
        cursor: pointer;
        &.nickName {
          font-family: PingFangSC-Semibold;
          color: rgba(23, 23, 38, 1);
        }
      }
    }

  }
}
.free-material {
  width: 200px;
  height: 20px;
  display: flex;
  align-items: center;
  // position: absolute;
  // top: 0%;
  // right: 0%;
  img {
    width: 30px;
    height: 20px;
  }
  a {
    cursor:pointer;
    width: 140px;
    height: 14px;
    margin-left: 12px;
  }
}
.newColor {
  background: #ff8f1f;
  color: #fff;
  padding: 5px 8px;
  border-radius: 5px;
  cursor: pointer;
}
.updown{
  margin-right: 50px;
  cursor: pointer;
}
</style>
